import type { CCategoryAdvertisementTranslations } from "./pl";

export const de: CCategoryAdvertisementTranslations = {
  emptyData: "Keine Daten zum Anzeigen.",
  articleNotFound: "Die Anzeige existiert nicht oder wurde entfernt.",
  noAdsInCategory: "Keine Anzeigen in dieser Kategorie.",
  noAdsFound: "Keine Anzeigen, die den angegebenen Kriterien entsprechen.",

  /* Search */
  searchTitle: "Suche",
  searchBtn: "Suchen",
  allTypes: "Alle Typen",
  fields: {
    keyword: "Suchbegriff",
    type: "Typ",
    priceFrom: "Preis ab",
    priceTo: "Preis bis",
  },
  validation: {
    invalidPrice: "Ungültiger Preiswert (max. 2 Dezimalstellen).",
  },

  resultsTitle: (n) =>
    n === 1 ? "1 Anzeige gefunden" : `${n} Anzeigen gefunden`,

  price: "Preis",
  negotiatedPrice: "Preis verhandelbar",
  priceNotSet: "-",
  readMore: "Mehr lesen",
  formatPrice: (value) => {
    try {
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "PLN",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    } catch {
      return `${value.toFixed(2)} PLN`;
    }
  },

  backToList: "Zurück zur Liste",
  addAdvert: "Anzeige hinzufügen",

  contact: "Kontakt",
  city: "Stadt",
  telephone: "Telefon",
  email: "E-Mail",

  contactForm: {
    title: "Nachricht an den Anbieter senden",
    submit: "Senden",
    sending: "Wird gesendet...",
    fields: {
      name: "Vor- und Nachname",
      email: "E-Mail",
      telephone: "Telefon (optional)",
      text: "Nachrichtentext",
      personalData:
        "Ich willige in die Verarbeitung meiner personenbezogenen Daten zum Zweck der Beantwortung meiner Nachricht ein.",
    },
    validation: {
      requiredName: "Bitte geben Sie Ihren Namen an.",
      requiredEmail: "Bitte geben Sie eine E-Mail-Adresse an.",
      invalidEmail: "Ungültige E-Mail-Adresse.",
      requiredText: "Bitte geben Sie den Nachrichtentext ein.",
      requiredPersonalData:
        "Die Einwilligung in die Verarbeitung personenbezogener Daten ist erforderlich.",
    },
    status: {
      sendSuccess: "Ihre Nachricht wurde gesendet. Vielen Dank!",
      sendFailed:
        "Die Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.",
      rateLimit:
        "Sie haben das Sendelimit für diese Adresse überschritten. Bitte versuchen Sie es in einer Stunde erneut.",
      waitBeforeSubmit: (s) =>
        `Bitte warten Sie ${s} s vor dem Senden (Bot-Schutz).`,
      networkError: (msg) =>
        `Netzwerkfehler: ${msg}. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.`,
      networkErrorGeneric:
        "Ein unerwarteter Fehler ist aufgetreten. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    },
  },
};
